<template>
  <div class="c-app page" :class="{ 'c-dark-theme': darkMode }">
    
    <CWrapper>
        <InfoToast />
        <div class="c-body">
            <main class="c-main p-0">
                <child />
            </main>
        </div>
    </CWrapper>
  </div>
</template>

<script>
import InfoToast from "£lement/InfoToast";
import { mapGetters } from "vuex";
export default {
    name: "PreviewLayout",

    components: {
        InfoToast
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode"
        })
    },
    data() {
        return {
            fixedToasts: 0,
        }
    },
    async mounted(){
        
            
    }
};
</script>
<style scoped lang="scss">
    .container-fluid{
        padding: 0;
    }
</style>
